<template>
  <b-container class="p-3" fluid>
    <portal to="project-action-bar">
      <template v-if="$auth.check('coordinator') && project.status === 'Draft'">
        <b-button :to="{ name: 'projects.show.proposal.basic.edit', params: $route.params }" variant="info"><font-awesome-icon icon="pencil-alt" />แก้ไขข้อมูล</b-button>
      </template>
    </portal>

    <loading-spinner v-if="isLoading" text="กำลังโหลด..." />
    <div v-else class="row">
      <div v-if="showRejectAlert" class="col-12">
        <reject-alert :changes="project.changeHistory[project.changeHistory.length - 1]" />
      </div>

      <div class="col-12">
        <signed-doc-uploader-card
          v-if="$auth.user().role === 'osda' && (project.status === 'WaitingForOsdaApproval' || project.status === 'Approved')"
          v-model="signedDocUploadFile"
          :status="project.signedDoc"
          class="mb-4"
          @upload="upload"
        />

        <show-proposal-basic-info v-model="project" />
      </div>
    </div>
  </b-container>
</template>

<script>
import SignedDocUploaderCard from '@/components/project/SignedDocUploaderCard'
import ShowProposalBasicInfo from '@/components/project/ShowProposalBasicInfo'
import LoadingSpinner from '@/components/layouts/LoadingSpinner'
import RejectAlert from '@/components/project/RejectAlert'

export default {
  components: {
    SignedDocUploaderCard,
    ShowProposalBasicInfo,
    LoadingSpinner,
    RejectAlert
  },
  data: () => ({
    isLoading: true,
    signedDocUploadFile: null
  }),
  computed: {
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) },
    showRejectAlert () {
      return this.project.changeHistory.length &&
        this.project.changeHistory[this.project.changeHistory.length - 1].comment &&
        !this.project.changeHistory[this.project.changeHistory.length - 1].comment.includes('[รายการแก้ไข] ')
    }
  },
  created () {
    this.$store.dispatch('project/loadBasicInfo', this.$route.params.id).then(() => {
      this.isLoading = false
    })
  },
  methods: {
    async upload () {
      let pdf = new FormData()
      pdf.append('pdf', this.signedDocUploadFile)
      pdf.append('projectId', this.$route.params.id)
      // You should have a server side REST API
      this.$axios.post(process.env.VUE_APP_API_BASE_URL + '/upload/signed/',
        pdf, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(() => {
        this.$store.dispatch('project/fetchProject', this.$route.params.id)
      })
    }
  }
}
</script>
